import { Injectable } from '@angular/core';

const APP_PREFIX = 'ANMS-';

@Injectable()
export class LocalStorageService {
  constructor() {}

  static loadInitialState() {
    return Object.keys(localStorage).reduce((state: any, storageKey) => {
      if (storageKey.includes(APP_PREFIX)) {
        const value = LocalStorageService.readItem(storageKey);
        if (value === undefined) {
          return state;
        }
        state = state || {};
        const stateKey = storageKey
          .replace(APP_PREFIX, '')
          .toLowerCase()
          .split('.');
        let currentStateRef = state;
        stateKey.forEach((key, index) => {
          if (index === stateKey.length - 1) {
            currentStateRef[key] = value;
            return;
          }
          currentStateRef[key] = currentStateRef[key] || {};
          currentStateRef = currentStateRef[key];
        });
      }
      return state;
    }, undefined);
  }

  setItem(key: string, value: any) {
    const serializedValue = JSON.stringify(value);
    if (serializedValue === undefined) {
      this.removeItem(key);
      return;
    }
    localStorage.setItem(`${APP_PREFIX}${key}`, serializedValue);
  }

  getItem(key: string) {
    return LocalStorageService.readItem(`${APP_PREFIX}${key}`) ?? null;
  }

  private static readItem(storageKey: string) {
    try {
      return JSON.parse(localStorage.getItem(storageKey));
    } catch {
      localStorage.removeItem(storageKey);
      return undefined;
    }
  }

  removeItem(key: string) {
    localStorage.removeItem(`${APP_PREFIX}${key}`);
  }
}
